import WhatComesNext from "../../components/Nursery/GeneralAwareness/WhatComesNext";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - Nursery - General Awareness - Day, Week & Month"; // Set page title

const topics: MenuItem[] = [
    { url: "/nursery/general-awareness/days-week-month/fill-blanks", title: "Fill in the Blanks", component: WhatComesNext},
    //{ url: "/nursery/general-awareness/days-week-month/match-color", title: "Match Same Color"},
];


export default topics;